import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { AuthActions } from './auth.actions';
import { UserProfile } from '@lyceo/shared/auth/util-models';
import { CallState, LoadingState } from '@lyceo/shared/util-loading';

export const AUTH_FEATURE_KEY: string = 'auth';

export interface AuthState {
  profile: UserProfile | undefined;
  isAuthenticated: boolean;
  loginCallState: CallState;
  logoutCallState: CallState;
}

export const initialAuthState: AuthState = {
  profile: undefined,
  isAuthenticated: false,
  loginCallState: LoadingState.INIT,
  logoutCallState: LoadingState.INIT,
};

const reducer: ActionReducer<AuthState, Action> = createReducer(
  initialAuthState,
  on(
    AuthActions.mobileLogoutFinish,
    (state): AuthState => ({
      ...state,
      logoutCallState: LoadingState.INIT,
    }),
  ),
  on(
    AuthActions.userLogout,
    AuthActions.storageTokenInvalid,
    AuthActions.sessionErrorLogout,
    (state): AuthState => ({
      ...state,
      profile: undefined,
      logoutCallState: LoadingState.LOADING,
    }),
  ),
  on(
    AuthActions.logoutSuccess,
    (state): AuthState => ({
      ...state,
      logoutCallState: LoadingState.LOADED,
    }),
  ),
  on(
    AuthActions.logoutFailure,
    (state): AuthState => ({
      ...state,
      logoutCallState: { errorMsg: '' },
    }),
  ),
  on(
    AuthActions.loadUserProfileSuccess,
    (state, { profile }): AuthState => ({
      ...state,
      profile,
    }),
  ),
  on(
    AuthActions.updateAuthenticated,
    (state, { isAuthenticated }): AuthState => ({
      ...state,
      isAuthenticated,
    }),
  ),
  on(
    AuthActions.loadDiscoveryDocument,
    AuthActions.retryLoadDiscoveryDocument,
    AuthActions.mobileTryLogin,
    AuthActions.login,
    (state): AuthState => ({
      ...state,
      loginCallState: LoadingState.LOADING,
    }),
  ),
  on(
    AuthActions.tryLoginSuccess,
    AuthActions.mobileTryLoginSuccess,
    (state): AuthState => ({
      ...state,
      loginCallState: LoadingState.LOADED,
    }),
  ),
  on(
    AuthActions.loadDiscoveryDocumentFailure,
    AuthActions.refreshingTokenFailure,
    (state): AuthState => ({
      ...state,
      loginCallState: { errorMsg: 'Error' },
    }),
  ),
  on(
    AuthActions.tryLoginFailure,
    (state): AuthState => ({
      ...state,
      loginCallState: LoadingState.LOADED,
    }),
  ),
);

export function authReducer(
  state: AuthState | undefined,
  action: Action,
): AuthState {
  return reducer(state, action);
}
